import React from "react";
import { motion } from "framer-motion";
import { PROBLEM } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

export default function Problem() {
  return (
    <section
      id="how"
      data-testid={PROBLEM.section}
      className="relative py-28 md:py-44 bg-[#FDFBF7]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-16 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease }}
            className="col-span-12 md:col-span-8"
          >
            <p className="overline mb-12">— Despre EILEA</p>
            <h2
              data-testid={PROBLEM.title}
              className="font-display text-[2.2rem] leading-[1.15] sm:text-4xl md:text-[3.3rem] lg:text-[4rem] text-[#2C2826] tracking-[-0.015em]"
            >
              Îți dorești confortul unei creme.
              <span className="accent-soft block mt-3 md:mt-4">
                Fără senzația unei creme.
              </span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease, delay: 0.15 }}
            className="col-span-12 md:col-span-4 md:pb-3"
          >
            <p
              data-testid={PROBLEM.body}
              className="text-base md:text-[1.05rem] leading-[1.85] text-[#5C5652] font-light"
            >
              Mai puține gesturi. Același confort pe piele.
            </p>
            <div className="mt-8 w-16 h-px bg-[#2C2826]/30" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
